import { InvalidFieldValue } from "common/SettingsView";
import { safeStr } from 'common/api';

const _WARNING_HEAD = "%WARN-ENOENT: ";

const _DEFAULT_SETTINGS = {
  blocked: false,
  ipv4url: null,
  ipv6url: null,
};

const valueOrNA = (input) => (input === "n/a" ? null : input);

export const parseFromTabs = (input) => {
  return input.trim().split("\n").reduce((acc, value)=>{
    const [field, fieldValue] = value.split(/:\s+/);
    if (field.trim().startsWith("Quota initial status")){
        acc.initial = fieldValue?.trim();
    }
    if (field.trim().startsWith("Block redirection IPv4")){
        acc.ipv4url = valueOrNA(fieldValue?.trim());
    }
    if (field.trim().startsWith("Block redirection IPv6")){
        acc.ipv6url = valueOrNA(fieldValue?.trim());
    }
    return acc;
  }, {});
}

const newBlock = (...codes) =>
  `\n${codes
    .filter((code) => code !== undefined && code.length > 0)
    .map((code) => code.trim("\n"))
    .join("\n")}\n`;

const setInialBlocking = (previous, { initial = false }) =>
  initial === previous.initial
    ? ""
    : initial === "blocked"
    ? "quota blocking initial"
    : "no quota blocking initial";

const preventWhiteSpaces = (value, fieldName) => {
  if (value.includes(" ") === true) {
    throw new InvalidFieldValue(fieldName, `value "${value}" contains spaces`);
  }
  return value;
};

const safeURL = (value, fieldName) => safeStr(preventWhiteSpaces(value, fieldName));

const setIPV4URL = (previous, { ipv4url = "" }) => {
  return ipv4url === previous.ipv4url || (ipv4url === "" && previous.ipv4url === null)
      ? ""
      : ipv4url === null || ipv4url.length === 0
      ? `no block redirect ipv4`
      : `block redirect ipv4 ${safeURL(ipv4url, "IPv4 Redirect URL")}`;
};
  

const setIPV6URL = (previous, { ipv6url = "" }) =>
  ipv6url === previous.ipv6url || (ipv6url === "" && previous.ipv6url === null) 
    ? ""
    : ipv6url === null || ipv6url.length === 0
    ? `no block redirect ipv6`
    : `block redirect ipv6 ${safeURL(ipv6url, "IPv6 Redirect URL")}`;

const updatePreviousConfig = (previous, expected) => {
  const settings = [
    setInialBlocking(previous, expected),
    setIPV4URL(previous, expected),
    setIPV6URL(previous, expected),
  ].filter((content) => content.length > 0);
  return settings.length > 0 ? newBlock("pkteng", ...settings, "exit") : "";
};

export const composeApplyCommand = (previous, expected) =>
  newBlock(
    "configure",
    updatePreviousConfig(previous, expected),
    "commit"
  ).trimLeft("\n");
